/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import {
  Card,
  CardContent,
  CardActionArea,
  Checkbox,
  Icon,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Switch,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { MoreVert } from '@material-ui/icons';
import withStyles from '@material-ui/core/styles/withStyles';
import { productCardStyle, displayResourceStyles, resourceFormStyle } from '../../css/style';

const styles = productCardStyle();
const displayStyles = displayResourceStyles();
const switchStyles = resourceFormStyle();
const IosSwitch = withStyles(switchStyles.iosSwitchStyles)(Switch);

class CategoryCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
      anchorEl: null,
      isMouseOver: false,
    };
  }

  handleMenuOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget, isMenuOpen: true });
  }

  handleMenuClose = () => {
    this.setState({ anchorEl: null, isMenuOpen: false });
  }

  onClickDelete = async () => {
    const { onClickDelete } = this.props;
    onClickDelete();
    this.handleMenuClose();
  }

  onClickDuplicate = (data) => {
    const {
      actions,
      apiToken,
    } = this.props;
    const resourcePath = ['categories'];
    const {
      id,
      image,
      hasWarning,
      ...dataCopy
    } = data;
    if (dataCopy.integrationPLU) delete dataCopy.integrationPLU;
    dataCopy.name = `Copy of ${dataCopy.name}`;
    actions.addResource(apiToken, dataCopy, ...resourcePath).then(() => {
      this.handleMenuClose();
    });
  };

  onCheck = (event, category) => {
    const { actions } = this.props;
    if (event.target.checked) {
      actions.selectItems([category]);
    } else {
      actions.unselectItem(category);
    }
  }

  onSwitch = () => {
    const { actions, apiToken, category } = this.props;
    const payload = [{ id: category.id }];
    if (category.isDisabled) {
      actions.updateResource(apiToken, payload, 'categories', 'enable');
    } else {
      actions.updateResource(apiToken, payload, 'categories', 'disable');
    }
  }

  render() {
    const {
      category,
      onClickEdit,
      isChecked,
    } = this.props;
    const { anchorEl, isMenuOpen, isMouseOver } = this.state;
    return (
      <Card
        style={isMouseOver ? styles.hoveredCardStyle : styles.cardStyle}
        onMouseOver={() => this.setState({ isMouseOver: true })}
        onMouseOut={() => this.setState({ isMouseOver: false })}
      >
        <CardContent style={styles.cardContentStyle}>
          <div style={styles.cardContentChildStyle}>
            <Checkbox
              style={styles.checkBoxStyle}
              checked={isChecked(category)}
              onChange={event => this.onCheck(event, category)}
              icon={(
                <Icon style={displayStyles.uncheckedCheckboxIcon}>
                  check_box_outline_blank
                </Icon>
              )}
              checkedIcon={<Icon style={displayStyles.checkedCheckboxIcon}>check_box</Icon>}
            />
            <CardActionArea
              onClick={onClickEdit}
              style={styles.categoryCardActionAreaStyle}
            >
              <div style={styles.actionAreaStyle}>
                <Typography style={styles.categoryNameTextStyle}>{category.name}</Typography>
              </div>
            </CardActionArea>
            <div style={styles.categorySwitchContainer}>
              <IosSwitch
                onChange={this.onSwitch}
                checked={!category.isDisabled}
              />
              <Typography style={styles.categoryHiddenText}>
                {category.isDisabled ? 'DISABLED' : 'ENABLED'}
              </Typography>
            </div>
            <IconButton
              style={styles.threeDotStyle}
              onClick={event => this.handleMenuOpen(event)}
            >
              <MoreVert />
            </IconButton>
            <Menu
              id={category.id}
              open={isMenuOpen}
              anchorEl={anchorEl}
              onClose={() => this.handleMenuClose()}
              getContentAnchorEl={null}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'bottom' }}
              transformOrigin={{ vertical: 'bottom', horizontal: 'bottom' }}
            >
              <MenuItem onClick={onClickEdit}>Edit</MenuItem>
              <MenuItem onClick={() => this.onClickDuplicate(category)}>Duplicate</MenuItem>
              <MenuItem onClick={() => this.onClickDelete(category)}>Delete</MenuItem>
            </Menu>
          </div>
        </CardContent>
      </Card>
    );
  }
}

CategoryCard.propTypes = {
  category: PropTypes.objectOf(PropTypes.any).isRequired,
  onClickDelete: PropTypes.func.isRequired,
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
  onClickEdit: PropTypes.func.isRequired,
  isChecked: PropTypes.func.isRequired,
};

export default CategoryCard;
